export function allowEditorPreview(): boolean | '/' {
	return typeof window === 'undefined' || window.self !== window.top ? true : '/'
}
